import React from "react";
import '../../sass/header.scss';
import {Button, createTheme, ThemeProvider} from "@mui/material";
import {Section} from "../../common/types/post.types";
import {useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";

const theme = createTheme({
  palette: {
    secondary: {
      // This is green.A700 as hex.
      main: '#020000',
    },
  },
});

function MenuBar() {
  const sections = useSelector((state: any) => state.sections.data)

  const listMainSections = sections.map((section: Section, index: number) => {
    return <EachMainSection index={index} section={section} key={index}/>
  });
  return (
    <div id={'menu-bar'}>
      <ThemeProvider theme={theme}>
        {listMainSections}
      </ThemeProvider>
    </div>
  );
}

export default MenuBar;

function EachMainSection(props: {index: number, section: Section}) {
  const navigate = useNavigate();

  function redirect() {
    navigate(`/sections/${props.section.path}`)
  }

  return (
    <Button color="secondary" variant="outlined" key={props.index} onClick={redirect}>{props.section.name}</Button>
  )
}
